const NAMESPACE = "mfaRequired";

const KEYS = {
    mfaRequiredHeader: "mfaRequiredHeader",
    mfaRequiredMessage: "mfaRequiredMessage",
    cancelText: "cancelText",
    goToMyAccountText: "goToMyAccountText"
};

const MESSAGES = {
    [KEYS.mfaRequiredHeader]: {
        value: "Multi-Factor Authentication Required",
        comment: "MFA Required dialog header text"
    },
    [KEYS.mfaRequiredMessage]: {
        value: "Your account must have Multi-Factor Authentication enabled in order to perform this operation. You can enable Multi-Factor Authentication from the My Account page.",
        comment: "MFA Required dialog message text"
    },
    [KEYS.cancelText]: {
        value: "Cancel",
        comment: "MFA Required dialog cancel button text"
    },
    [KEYS.goToMyAccountText]: {
        value: "Go to My Account",
        comment: "MFA Required dialog My Account button text"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
